"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeltaTags = exports.getTags = void 0;
const getTags = (html) => {
    const regex = /\[\[([^\]]+?)\]\]/g;
    const results = [];
    if (html) {
        let match;
        while ((match = regex.exec(html)) !== null) {
            results.push(match[1]);
        }
    }
    return results;
};
exports.getTags = getTags;
const getDeltaTags = (html) => {
    const result = [];
    const regex = /<delta-tag[^>]*id=["'](.*?)["'][^>]*>(\[\[(.*?)\]\])<\/delta-tag>/gm;
    if (html) {
        let m;
        while ((m = regex.exec(html)) !== null) {
            if (m.index === regex.lastIndex)
                regex.lastIndex++;
            const [, id, , tag] = m;
            if (id && tag) {
                result.push({ id, tag });
            }
        }
    }
    return result;
};
exports.getDeltaTags = getDeltaTags;
